import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Switch,
  VStack,
  useToast,
  Text,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import axios from "axios";
import { api_url } from "../../../url";
import CustomSwitch from "../CustomSwitch";

export default function EditProviderModal({
  isOpen,
  onClose,
  provider,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    providerId: "",
    aggregator: "",
    status: true,
  });

  useEffect(() => {
    if (provider) {
      setFormData({
        name: provider.name || "",
        slug: provider.slug || "",
        providerId: provider.providerId || "",
        aggregator: provider.aggregator || "",
        status: provider.status ?? true,
      });
    }
  }, [provider]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      // Only send fields that are allowed to be updated ideally, or just send all
      const payload = { ...formData };

      const { data } = await axios.put(
        `${api_url}/providers/${provider._id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (data.success) {
        toast({
          title: "Provider updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onSuccess();
        onClose();
      }
    } catch (error) {
      toast({
        title: "Error updating provider",
        description: error.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Provider</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Provider Name</FormLabel>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="e.g. Evolution Gaming"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Slug</FormLabel>
                <Input
                  name="slug"
                  value={formData.slug}
                  onChange={handleChange}
                  placeholder="e.g. evolution-gaming"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Provider ID</FormLabel>
                <Input
                  name="providerId"
                  value={formData.providerId}
                  onChange={handleChange}
                  placeholder="External Provider ID"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Aggregator</FormLabel>
                <Input
                  name="aggregator"
                  value={formData.aggregator}
                  onChange={handleChange}
                  placeholder="Aggregator Name"
                />
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel htmlFor="status-switch-edit" mb="0">
                  Provider Status
                </FormLabel>
                <CustomSwitch
                  name="status"
                  isChecked={formData.status}
                  onChange={handleChange}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" type="submit" isLoading={loading}>
              Update Provider
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
